import type {
  NooLoginResultOtpPending,
  NooLoginResultPendingReview,
  NooLoginResultResumeRegistration,
} from './buyer-login-incomplete-types';
import {
  type HomepageNooRegistrationResumeStep,
  buildHomepageNooRegistrationResumeUrl,
} from './homepage-urls';
import { NOO_REGISTRATION_STATUS_PATH } from './noo-registration-status-urls';

export type BuyerRegistrationIncompleteNavigation =
  | { type: 'buyer'; href: string }
  | { type: 'external'; href: string };

function buildBuyerStatusHref(registrationToken: string): string {
  const params = new URLSearchParams({
    registration_token: registrationToken,
  });
  return `${NOO_REGISTRATION_STATUS_PATH}?${params.toString()}`;
}

function buildHomepageResumeHref(
  step: HomepageNooRegistrationResumeStep,
  registrationToken?: string,
): string {
  return buildHomepageNooRegistrationResumeUrl({
    step,
    registrationToken,
  });
}

export function resolveBuyerRegistrationIncompleteNavigation(
  result:
    | NooLoginResultPendingReview
    | NooLoginResultResumeRegistration
    | NooLoginResultOtpPending,
): BuyerRegistrationIncompleteNavigation {
  switch (result.kind) {
    case 'pending_review':
      return {
        type: 'buyer',
        href: buildBuyerStatusHref(result.registration_token),
      };
    case 'resume_registration':
      return {
        type: 'external',
        href: buildHomepageResumeHref(
          'document-incomplete',
          result.registration_token,
        ),
      };
    case 'otp_pending':
      return {
        type: 'external',
        href: buildHomepageResumeHref('otp'),
      };
    default:
      return {
        type: 'external',
        href: buildHomepageResumeHref('login'),
      };
  }
}
